import { getRequest } from 'config/Axios/baseConfig';
import { loginReponseInterface } from 'Interfaces/authInterface';
import { userInfoInterface } from 'Interfaces/User/userInterfaces';

export interface User {
  id: number;
  name: string;
  email: string;
  deptId: {
    id: number;
    departmentName: string;
    departmentCode: string;
    createdAt: string;
    updatedAt: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface UsersListResponse {
  users: User[];
  count: number;
}

export const authServices = {
  getUserInfoAndRoles: (): Promise<userInfoInterface> =>
    getRequest<userInfoInterface>(`auth/user-info`)
      .then(({ data }) => data)
      .catch(error => {
        console.log('in auth services > getUserInfoAndRoles, Err===', error);
        throw error;
      }),

  initiateLogin: (): Promise<loginReponseInterface> =>
    getRequest<loginReponseInterface>(`auth/initiate-login`)
      .then(({ data }) => data)
      .catch(error => {
        console.log('in auth services > initiateLogin, Err===', error);
        throw error;
      }),

  getUsersList: (): Promise<UsersListResponse> =>
    getRequest<UsersListResponse>(`auth/users/list`)
      .then(({ data }) => data)
      .catch(error => {
        console.log('in auth services > getUsersList, Err===', error);
        throw error;
      })
};
